import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { isCanceled, logApiError } from 'services/apiError'
import useAbortController from 'hooks/useAbortController'
import useDebouncedValue from 'hooks/useDebouncedValue'
import BusinessBillList from 'components/Lists/BusinessBillList'
import AddBillModal from 'pages/Modals/AddBillModal'
// import CreateScheduleModal from 'pages/Modals/CreateScheduleModal'
import TextInput from 'components/Inputs/TextInput'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { FaPlus } from 'react-icons/fa'
import { ListContainer, Row } from '../styles'

export default function OpenBills () {
  const [loading, setLoading] = useState (true)
  const [openBills, setOpenBills] = useState ([])
  const [billData, setBillData] = useState (null)
  const [customerName, setCustomerName] = useState ('')
  const debouncedCustomerName = useDebouncedValue(customerName, 500)
  const { abortarPendentes } = useAbortController()
  const [showAddBillModal, setShowAddBillModal] = useState (false)
  // const [showCreateScheduleModal, setShowCreateScheduleModal] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [debouncedCustomerName])

  const getData = async () => {
    const signal = abortarPendentes()

    try {
      setLoading (true)

      const filters = `deleted=false&open=true&customer_name=${encodeURIComponent(debouncedCustomerName)}`

      const { data: openBills } = await cutileiApi.get (
        `/business_bills?business_id=${businessId}&${filters}`,
        { ...requestConfig, signal }
      )

      setOpenBills (openBills)
    } catch (error) {
      if (isCanceled(error)) return
      logApiError (error)
    } finally {
      if (!signal.aborted) setLoading (false)
    }
  }

  const handleEditBill = bill => {
    setOpenBills (openBills.map (b => b.id === bill.id ? bill : b))
  }

  const handleDeleteBill = bill => {
    setOpenBills (openBills.filter (b => b.id !== bill.id))
  }

  const toggleAddBillModal = () => setShowAddBillModal (!showAddBillModal) 
  // const toggleCreateScheduleModal = () => setShowCreateScheduleModal (!showCreateScheduleModal) 
  
  return (
    <ListContainer>
      {AuthService.hasPermission ('financial.open_bills', 'edit') && (
        <Row style={{marginBottom: 15}}>
          <TextInput
            value={customerName}
            placeholder='Buscar por cliente'
            isClearable={true}
            onChange={e => setCustomerName (e.target.value)}
            onClear={() => setCustomerName ('')}
            inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
            containerStyle={{width: 280}}
          />
          <SecondaryButton
            label='Abrir comanda'
            leftIcon={<FaPlus size={12} color='#FFC100' style={{marginBottom: 1}}/>}
            onClick={toggleAddBillModal}
            width={160}
          />
          <AddBillModal
            visible={showAddBillModal}
            onConfirm={bill => {
              setBillData (bill)
              setOpenBills ([...openBills, bill])
            }}
            onClose={toggleAddBillModal}
          />
        </Row>
      )}
      {loading ? <Loading/> : (
        <BusinessBillList
          bills={openBills}
          editBillData={billData}
          onEdit={handleEditBill}
          onCloseBill={handleDeleteBill}
          onDelete={handleDeleteBill}
        />
      )}
      {/* <CreateScheduleModal
        visible={showAddScheduleModal}
        onConfirm={() => history.replace ('/business')}
        onClose={toggleAddScheduleModal}
      /> */}
    </ListContainer>
  )
}
